<!-- Container -->
<div class="kt-container-fixed">
	Page content builder
</div>
<!-- End of Container -->